import { render, staticRenderFns } from "./ShapeEditingModal.vue?vue&type=template&id=5e155c82&scoped=true&"
import script from "./ShapeEditingModal.vue?vue&type=script&lang=js&"
export * from "./ShapeEditingModal.vue?vue&type=script&lang=js&"
import style0 from "./ShapeEditingModal.vue?vue&type=style&index=0&id=5e155c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e155c82",
  null
  
)

export default component.exports